import React, { useEffect, useState } from 'react'
import { StaticQuery, graphql, useScrollRestoration } from 'gatsby'
import { PrismicProvider } from '@prismicio/react'

import { linkResolver } from '../util/linkResolver'
import { GlobalStyles } from './styles/Global.styles'
import * as Styled from './styles/Layout.styles'
import PrimaryNavigation from './PrimaryNavigation/PrimaryNavigation'
import Header from './Header'
import Footer from './Footer'
import CookieBanner from './ContentBlocks/CookieBanner'
import { NAV_MENU_STATUS } from '../util/constants'
import { isEdge } from '../util/helper'
import {
  AnchorAdWrapper,
  AnchorAdContent,
  AnchorCloseButton,
} from './styles/AnchorAdSlot.styles'

const COOKIE_BANNER_QUERY = graphql`
  {
    prismicGeneralSiteSettings {
      id
      data {
        cookie_popup_text {
          richText
        }
      }
    }
  }
`

const Layout = ({ children, renderAnchor = true }) => {
  const [navMenuStatus, setNavMenuStatus] = useState(NAV_MENU_STATUS.CLOSED)
  const contentRegionScrollRestoration = useScrollRestoration('content-region')
  const scrollRestoration = isEdge ? {} : contentRegionScrollRestoration
  const isNavMenuOpen = () => navMenuStatus !== NAV_MENU_STATUS.CLOSED

  return (
    <>
      <GlobalStyles />
      <PrismicProvider linkResolver={linkResolver}>
        <Styled.LayoutContainer isNavMenuOpen={isNavMenuOpen()}>
          <PrimaryNavigation
            navMenuStatus={navMenuStatus}
            setNavMenuStatus={setNavMenuStatus}
          />
          <Styled.ContentRegion
            id="ContentRegion"
            onClick={() => {
              if (isNavMenuOpen()) {
                setNavMenuStatus(NAV_MENU_STATUS.CLOSED)
              }
            }}
            {...scrollRestoration}
          >
            <Header />
            <Styled.PageContent>{children}</Styled.PageContent>
            <Footer />
          </Styled.ContentRegion>

          <StaticQuery
            query={`${COOKIE_BANNER_QUERY}`}
            render={data => {
              const copy =
                data?.prismicGeneralSiteSettings?.data.cookie_popup_text

              return (
                <CookieBanner isNavMenuOpen={isNavMenuOpen()} copy={copy} />
              )
            }}
          />
        </Styled.LayoutContainer>
        {renderAnchor && (
          <AnchorAdWrapper>
            <AnchorAdContent id="anchor" />
            <AnchorCloseButton
              onClick={() => {
                const container = document.getElementById('anchor')
                if (container) {
                  container.parentElement.style.display = 'none'
                  // console.log('ADTEST: Anchor ad closed')
                }
              }}
            >
              Close
            </AnchorCloseButton>
          </AnchorAdWrapper>
        )}
      </PrismicProvider>
    </>
  )
}

export default Layout
